import { Component, OnInit } from '@angular/core';

import { Platform, AlertController } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public appPages = [
    {
      title: 'Apps',
      url: '/folder/Apps',
      icon: 'apps'
    },
    {
      title: 'Contact',
      url: '/folder/Contact',
      icon: 'browsers'
    },
    {
      title: 'Support',
      url: '/folder/Support',
      icon: 'help'
    }
  ];
  public labels = [];

  constructor(
    private platform: Platform,
    private alertController: AlertController,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
    });
  }

  ngOnInit() {
    const path = window.location.pathname.split('folder/')[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
    }

    this.presentAlert();
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'New 1RISK Portal Page',
      message: 'The 1RISK portal page is now located at https://apps.1risk.cloud. Please update your bookmarks accordingly and contact 1RISK support should you have any issues.',
      buttons: ['OK'],
    });

    await alert.present();
  }
}
